module.exports = __webpack_public_path__ + "assets/img/img_url_huanghe.93f4034c.png";